import { TrackerClockDemo } from "./TrackerClockDemo";

/*
 * Replicants -- BeOS's live, draggable view embedding (BShelf + BDragger).
 *
 * A replicant is a BView an app publishes so *another* app can host it: the
 * host runs a BShelf, the view carries a BDragger handle, and dragging the
 * handle copies the live view (and its code, loaded from the originating
 * add-on) into the shelf. The Deskbar's status tray and the Desktop are both
 * shelves, which is why the clock lives here rather than under App
 * Reproductions -- TTimeView is not an app, it is a replicant in the Deskbar's
 * status shelf.
 */
export function Replicants() {
	return (
		<section id="replicants" className="demo-category">
			<h1>Replicants</h1>
			<p>
				Live views one app publishes for another to host (<code>BShelf</code> + <code>BDragger</code>). The host runs a shelf; the replicant
				carries a drag handle, and dropping it copies the running view — code and all — into the host. The Deskbar's status tray and the
				Desktop are both shelves.
			</p>
			<TrackerClockDemo />
		</section>
	);
}
